import avroIdl from "refractor/avro-idl";
export default avroIdl;